import React from 'react';
import PropTypes from 'prop-types';

const Chat = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect x="12" y="14" width="24" height="18" rx="8" fill={color}/>
      <circle cx="20" cy="23" r="2.2" fill="#0C1A3C"/>
      <circle cx="28" cy="23" r="2.2" fill="#0C1A3C"/>
      <rect x="16" y="18" width="16" height="3" rx="1.5" fill={color}/>
      <rect x="23" y="10" width="2" height="4" rx="1" fill={color}/>
      <circle cx="24" cy="9" r="1.4" fill={color}/>
    </svg>
  );
}

Chat.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Chat.defaultProps = {
  color: '#FFFFFF',
  width: 48,
  height: 48,
};

export default Chat;



// WEBPACK FOOTER //
// ./src/components/Icons/Chat.jsx